var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.itemsTipo,"loading":_vm.loading,"rules":_vm.rules,"label":"Tipo de notificação"},model:{value:(_vm.tipo),callback:function ($$v) {_vm.tipo=$$v},expression:"tipo"}})}
var staticRenderFns = []

export { render, staticRenderFns }